import {outter_post} from 'common/js/axios-helper';
import {OrganRateApi} from "./constant/UrlMapper";


const host = '8880';
const add = (data) => {
    return outter_post(OrganRateApi.Add, data, host);
};

const list = (data) => {
    return outter_post(OrganRateApi.List, data, host);
};

const update = (data) => {
    return outter_post(OrganRateApi.Update, data, host);
};

const dpstatus = (data) => {
    return outter_post(OrganRateApi.DpStatus, data, host);
};

const detail = (data) => {
    return outter_post(OrganRateApi.Detail, data, host);
};

const del = (data) => {
    return outter_post(OrganRateApi.Delete, data, host);
};
const bankCardResource = (data) => {
    return outter_post(OrganRateApi.BankCardResource, data, host);
};
const cardOrderList = (data) => {
    return outter_post(OrganRateApi.CardOrderList, data, host);
};
const cardCloseOrder = (data) => {
    return outter_post(OrganRateApi.CardCloseOrder, data, host);
};


export default {add, list, update, dpstatus, detail, del, cardOrderList, cardCloseOrder}



// WEBPACK FOOTER //
// ./src/service/OrganRateService.js